import classnames from 'classnames/bind'
import Error from 'entities/error'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './error_summary.module.scss'

const ErrorSummary = ({ className, error }) => (
  <div className={classnames(className, styles.errorSummary)}>{error.message}</div>
)

ErrorSummary.propTypes = {
  className: PropTypes.string,
  error: PropTypes.instanceOf(Error).isRequired
}

ErrorSummary.defaultProps = {
  className: null
}

export default ErrorSummary
